// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__2knww","text":"landing_text__2uWcs","mobileText":"landing_mobileText__2_LaL","land":"landing_land___VzKh"};